import React, { useEffect } from "react";
import { FileText, ExternalLink } from "lucide-react";

function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("sr-visible")),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".sr").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

const reports = [
  { year: 2023, file: "/files/annual-report-2023.pdf" },
  { year: 2022, file: "/files/annual-report-2022.pdf" },
  { year: 2021, file: "/files/annual-report-2021.pdf" },
];

const AnnualReports = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">

        <div className="sr text-center mb-12">
          <h1 className="text-4xl font-bold mb-3">Annual Reports</h1>
          <p className="text-gray-500 text-sm max-w-md mx-auto">
            Download previous bursary programme annual reports for reference and transparency.
          </p>
          <div className="w-20 h-1 bg-primary rounded-full mx-auto mt-5" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reports.map((r, idx) => (
            <a
              key={idx}
              href={r.file}
              target="_blank"
              rel="noopener noreferrer"
              className="sr group bg-white rounded-2xl shadow-md p-8 flex flex-col items-center gap-4 border border-gray-100 hover:shadow-xl hover:-translate-y-2 hover:border-blue-200 transition-all duration-300"
              style={{ transitionDelay: `${0.1 + idx * 0.08}s` }}
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                <FileText size={28} className="text-primary" />
              </div>
              <h3 className="font-semibold text-gray-800 text-lg">{r.year} Report</h3>
              <span className="text-xs text-gray-400 flex items-center gap-1 group-hover:text-primary transition-colors duration-200">
                <ExternalLink size={12} /> Download PDF
              </span>
            </a>
          ))}
        </div>
      </div>

      <style>{`
        .sr { opacity: 0; transform: translateY(22px); transition: opacity 0.55s ease, transform 0.55s ease; }
        .sr-visible { opacity: 1; transform: translateY(0); }
      `}</style>
    </div>
  );
};

export default AnnualReports;